"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _main = _interopRequireDefault(require("../menu/main.sync"));

var _zod = require("zod");

var _userContext = require("../../server-middleware/userContext");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _index = _interopRequireDefault(require("../client-component/index.server"));

var _Dropdown = _interopRequireDefault(require("../User/Dropdown"));

var _SearchForm = _interopRequireDefault(require("../algolia/components/SearchForm"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'navigation_bar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-navigation_bar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

function isTopicNew() {
  if (typeof window === 'undefined') return null;
  return window.location.pathname.match(/^\/topic\/new/);
}

function shouldShowSearch() {
  if (typeof window === 'undefined') return false;
  return document.querySelector('.searchbar-in-hero') === null && location.pathname !== '/search';
}

var NavigationBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavigationBar, _Component);

  var _super = _createSuper(NavigationBar);

  function NavigationBar() {
    (0, _classCallCheck2.default)(this, NavigationBar);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(NavigationBar, [{
    key: "render",
    value: function render() {
      var _this = this;

      return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
        return (0, _preact.h)("nav", {
          className: (0, _classnames.default)('main-navigation--wrapper', 'qa-main-navigation', 'custom-navigation'),
          "data-entity": "NavigationBar"
        }, (0, _preact.h)("div", {
          className: "main-navigation-sitewidth"
        }, (0, _index.default)(_main.default, 'menu/main', {
          communityCategories: _this.props.categoryGroups,
          knowledgeBaseCategories: _this.props.knowledgeBaseCategories,
          showActivitySinceLastVisit: !!user.id
        }), shouldShowSearch() && (0, _preact.h)("section", {
          className: "main-navigation--search-wrapper is-hidden-mobile-only"
        }, (0, _index.default)(_SearchForm.default, 'algolia/components/SearchForm', {
          isUserGuest: !user.id,
          isFederatedSalesforceSearch: _this.props.isFederatedSalesforceSearch,
          isFederatedSkilljarSearch: _this.props.isFederatedSkilljarSearch,
          isFederatedFreshdeskSearch: _this.props.isFederatedFreshdeskSearch
        })), (0, _preact.h)("section", {
          className: "main-navigation--nav-buttons-wrapper",
          "data-view": "MainNavigation"
        }, (0, _preact.h)("ul", null, !isTopicNew() ? (0, _preact.h)("li", {
          className: "is-hidden-S"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new"),
          "data-track": JSON.stringify({
            trigger: 'navigation',
            type: 'Topic Initiated'
          }),
          "data-ga-track": JSON.stringify({
            eventCategory: 'Homepage',
            eventAction: 'Create topic clicked',
            eventLabel: {
              Position: 'Navigation'
            }
          }),
          className: (0, _classnames.default)('link', 'menu-create-topic', 'qa-menu-create-topic'),
          tabIndex: 0,
          role: "button"
        }, (0, _preact.h)("span", {
          className: "icon--pen icon--auto-width",
          "aria-hidden": "true"
        }), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: "main.navigation.add_topic"
        })))) : null, !user.id ? (0, _preact.h)("li", null, _this.props.ssoLoginUrl ? (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(_this.props.ssoLoginUrl),
          tabIndex: 0,
          role: "button",
          className: "link qa-header-login-button"
        }, (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.login"
        })) : (0, _preact.h)("a", {
          href: "#",
          className: (0, _classnames.default)('link', 'js-open-modal', 'qa-header-login-button'),
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return window.app.events.commands.execute('modal:login:show');
          }
        }, (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.login"
        }))) : (0, _preact.h)(_Dropdown.default, (0, _extends2.default)({}, user, {
          size: "S"
        }))))));
      });
    }
  }]);
  return NavigationBar;
}(_preact.Component);

var _default = NavigationBar;
exports.default = _default;